module.exports = __webpack_public_path__ + "static/media/y5.f1110756.png";